import { useMutation } from "convex/react";
import { api } from "@constructionautomation/backend";
import { toTitleCase } from "@/lib/formatting";
import { Button } from "@/components/ui/button";
import type { AiCountPage } from "./ai-count-types";

export function AiCountIssues({ issues, disabled, tagName, onShowIssue, onAction }: {
  issues: AiCountPage["issues"];
  disabled: boolean;
  tagName: (id: string) => string;
  onShowIssue: (issueId: string) => void;
  onAction: (work: () => Promise<unknown>) => void;
}) {
  const resolve = useMutation(api.takeoffPilot.jobs.resolveAiCountIssue);
  return issues.map((issue) => (
    <div key={issue._id} className="space-y-2 rounded-md border-2 border-status-pending/40 bg-status-pending/5 p-3">
      <p className="font-medium">
        {issue.tagId ? `${tagName(issue.tagId)}: ` : ""}
        {toTitleCase(issue.category)}
      </p>
      <p className="text-muted-foreground">
        {issue.evidence.includes("located_issue:") ? "Check this area for missing items or unclear tags." : issue.evidence}
      </p>
      {issue.neededContext && <p className="text-xs text-muted-foreground">{issue.neededContext}</p>}
      <div className="flex flex-wrap gap-2">
        {issue.bbox && (
          <Button size="sm" variant="ghost" onClick={() => onShowIssue(issue._id)}>
            Show area on drawing
          </Button>
        )}
        <Button
          size="sm"
          variant="outline"
          disabled={disabled}
          onClick={() => onAction(() => resolve({ issueId: issue._id, expectedVersion: issue.version }))}
        >
          Mark as reviewed
        </Button>
      </div>
    </div>
  ));
}
